@import "../../../../styles/variables";
:host {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  height: 48px;
  background-color: $svs-white;
  padding: 0 8px;

  .hm-left-button {
    display: flex;
    align-items: center;
    height: 100%;
    background-color: $svs-white;
  }

  .hm-right-chips {
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    max-width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .hm-button {
    border: none;
    background: none;
    margin: 0;
    padding: 0;

    &.margin-r-10 {
      margin-right: 10px;
    }
  }

  .cta-color {
    color: $svs-anthracite-grey;
  }
}

:host(.hm-no-chips) {
  justify-content: space-between;
}

:host(.static) {
  margin-bottom: 20px;
  border: 1px solid $svs-super-light-grey;
}

:host(.none-static) {
  box-shadow: 0 0 5px rgba(#333333, 0.05);
  z-index: 999;
}

:host(.more-height),
:host(.fixed-view) {
  height: 54px;
}
